<template>
  <div class="cTextInput-container">
    <input
      type="text"
      autocorrect="off"
      autocapitalize="off"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="modelVal"
      :class="{ inputEdited: value, inputRad: show }"
      @blur="handleblur"
      @focus="handleComposing($event)"
      @input="getVal($event)"
    />
    <ul class="search-list" v-if="show">
      <li
        class="search-item"
        v-for="(option, key) in searchData"
        :key="`scr_${key}`"
        @click="checkVal(option)"
      >
        {{ option.value }}
      </li>
    </ul>
    <ul class="search-list" v-show="shownodata" @click="close">
      <li class="search-item">金融機関には該当データが存在しません。</li>
    </ul>
  </div>
</template>

<script>
// 防抖函数
function debounce(func, wait = 500) {
  let timeout;
  return function (event) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.call(this, event);
    }, wait);
  };
}
export default {
  name: 'InputISearch',
  props: [
    'value',
    'placeholder', //提示信息
    'message', //错误信息
    'formatError',
    'disabled'
  ],
  watch: {
    value: function (newVal, oldVal) {
      this.modelVal = newVal;
    }
  },
  computed: {},
  data() {
    return {
      modelVal: this.value,
      searchData: [],
      show: false,
      shownodata: false
    };
  },
  methods: {
    getVal: debounce(function ($event) {
      if (!$event.target.value.trim()) {
        this.show = false;
        this.searchData = [];
      }
      this.$emit('input', $event.target.value.trim());
    }),
    //正在输入
    handleComposing: debounce(function ($event) {
      if ($event.target.value.trim()) {
        this.$emit('input', $event.target.value.trim());
      } else {
        this.$emit('handlefocus', '');
      }
    }),
    // 失去焦点，校验信息
    handleblur() {
      setTimeout(() => {
        this.show = false;
        this.shownodata = false;
      }, 300);
      this.$emit('inputblur');
    },
    setSearchData(data) {
      if (data.length > 0) {
        this.show = true;
        this.shownodata = false;
        this.searchData = data;
      } else {
        this.show = false;
        this.shownodata = true;
        this.searchData = data;
      }
    },
    close() {
      this.shownodata = false;
    },
    checkVal: debounce(function (options) {
      this.$emit('handleCheck', options);
      this.show = false;
    })
  }
};
</script>
<style scoped lang="less">
.cTextInput-container {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;

  input {
    height: 0.5rem;
    background: var(--bg-pinkcolor);
    border: 2px solid var(--maincolor);
    font-size: 0.16rem;
    line-height: 0.5rem;
    color: var(--text-graycolor);
    padding: 0 0.14rem;
    width: 100%;
    border-radius: 5px;
  }

  .inputRad {
    border-radius: 5px 5px 0 0;
  }

  .search-list {
    font-size: 0.18rem;
    position: absolute;
    left: 0;
    top: 0.5rem;
    background: white;
    width: 100%;
    height: 2.8rem;
    overflow-y: auto;
    z-index: 99;
    .search-item {
      padding: 0.15rem;
      border-bottom: 1px solid #a6a6a638;
      border-radius: 0 0 2px 2px;
      cursor: pointer;
    }
  }

  .inputEdited {
    background-color: #ffffff;
    color: #333333;
  }

  .error {
    border: 1px solid red;
  }

  .inputMessage {
    padding: 0 0.05rem;
    color: red;
    font-size: 0.12rem;
    line-height: 0.14rem;
    min-height: 0.28rem;
    white-space: pre-wrap;
    margin-top: 0.05rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/cSearchInput.vue